export default {
    byPublication(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('publicationId', id).get()
            )
        )
    }
}
